/**
 * Lower bound, in hours, of each "Time to Submit" bucket; the last is open-ended.
 * Sent as `time_to_submit_bucket_starts_hours`.
 */
export const HOUR_BUCKET_STARTS = [0, 6, 12, 18, 24, 36, 48] as const;
